import { differenceInHours } from 'date-fns/differenceInHours'
import { combine, createStore } from 'effector'
import { and, or } from 'patronum'

import { $portalProfile, gameLevelUp, persistProfileData } from '@/entities/profile/portal'

const hoursToWait = 10
const levelToReach = 7

// we have to store level-reached flag in local storage because level in profile is updated with a noticeable delay
const $storedLevelReached = createStore(false).on(gameLevelUp, (reached, { level }) => reached || level >= levelToReach)
persistProfileData({
    store: $storedLevelReached,
    key: 'chat.enter.level-reached',
})

export const $isEmailVerified = $portalProfile.map((profile) => !profile?.emailNeedVerify)
export const $isGameLevelReached = or(
    $portalProfile.map((profile) => profile !== null && profile.level >= levelToReach),
    $storedLevelReached
)
export const $isNameSet = $portalProfile.map((profile) => profile !== null && profile.nick.trim() !== '')
export const $isAvatarSet = $portalProfile.map((profile) => profile !== null && profile.imageURL.trim() !== '')

// TODO update time every minute
const $now = createStore(new Date())
export const $isRegistrationTimePassed = combine($portalProfile, $now).map(
    ([profile, now]) => differenceInHours(now, profile?.createTime ?? 0) >= hoursToWait
)

export const $isEnterListComplete = and(
    $isEmailVerified,
    $isGameLevelReached,
    $isRegistrationTimePassed,
    $isNameSet,
    $isAvatarSet
)
